import React from "react"
import ShareComponent from "./ShareComponent"
import Share from './../images/icons/share.png'
import QuestionMark from './../images/icons/question-mark.svg'
import Bookmark from './../images/icons/bookmark.png'
import Notes from './../images/icons/note.png'
import download from "./../images/icons/download-gray.png"
import Print from './../images/icons/print.png'
import Arrow from './../images/icons/arrow-bg.png'
import { Link } from "@reach/router"
import { bookmark_fill } from "../images/export"
import { getOfflineToken } from "../../Helper"


interface IActionButtons {
	showShare?: boolean
	shareText?: (e?: boolean) => string
	mailText?: () => string
	onShare?: () => void
	onQuestionMark?: () => void
	onBookMark?: () => void
	onNote?: () => void
	onDownloadPdf?: () => void
	onPrint?: () => void
	data?: { prev?: string | number, next?: string | number }
	hasBookmark?: boolean;
	visibles?: {
		share?: boolean,
		questionMark?: boolean;
		bookMark?: boolean;
		note?: boolean;
		downloadPdf?: boolean
		print?: boolean;
	}
}

export const ActionButtons: React.FC<IActionButtons> = ({
	showShare, shareText, mailText, onShare, onQuestionMark, onBookMark, onNote, onDownloadPdf, onPrint, data, hasBookmark,
	visibles = { bookMark: true, downloadPdf: true, note: true, print: true, questionMark: true, share: true }
}) => <div className="flexed">
		{visibles.share ? <div className="flexed">
			{showShare && <ShareComponent
				getShareText={shareText}
				getMailText={mailText}
				className="flexed slideInBottom absolute"
				style={{ bottom: 'calc(-30% - 32px)', right: '-100%' }}
			/>}
			<button className="bd-none bg-none icon-button mx-8 p-0" title="اشتراک گذاری" onClick={onShare}>
				<img className="icon-sm valign-mid button" src={Share} alt="" />
			</button>
		</div> : null}
		{visibles.questionMark ? <button className="bd-none bg-none icon-button mx-8 p-0" title="پرسش از مقرره"
			onClick={onQuestionMark}>
			<img className="icon-sm valign-mid" style={{ transform: 'scale(1.1)' }} src={QuestionMark} alt="" />
		</button> : null}
		{getOfflineToken() && visibles.bookMark ? <button className="bd-none bg-none icon-button mx-8 p-0" title="اخبار من"
			onClick={onBookMark}>
			<img className="icon-sm valign-mid p-2" src={hasBookmark ? bookmark_fill : Bookmark} alt="" />
		</button> : null}
		{visibles.note ? <button className="bd-none bg-none icon-button mx-8 p-0" title="یادداشت های من"
			onClick={onNote}>
			<img className="icon valign-mid p-4" src={Notes} alt="" />
		</button> : null}

		{visibles.downloadPdf ? <button className="bd-none bg-none icon-button mx-8 p-0" title="دانلود" onClick={onDownloadPdf}>
			<img className="icon valign-mid p-4" src={download} alt="" />
		</button> : null}

		{visibles.print ? <button className="bd-none bg-none icon-button mx-8 p-0 ml-22" title="چاپ" onClick={onPrint}>
			<img className="icon valign-mid p-4" src={Print} alt="" />
		</button> : null}
		{data && <> <button className="bd-none bg-none icon-button mx-8 p-0" title="قبلی">
			{data?.prev ? <Link to={`/library/laws/${data.prev}`}>
				<img className="icon-md valign-mid button" src={Arrow} alt="" />
			</Link> : <img className="icon-md valign-mid button blocked" src={Arrow} alt="" style={{ filter: 'grayscale(1)' }} />}
		</button>
			<button className="bd-none bg-none icon-button mx-8 p-0" title="بعدی" style={{ transform: 'rotate(180deg)' }}>
				{data?.next ? <Link to={`/library/laws/${data.next}`}>
					<img className="icon-md valign-mid button" src={Arrow} alt="" />
				</Link> : <img className="icon-md valign-mid button" src={Arrow} alt="" style={{ filter: 'grayscale(1)' }} />}
			</button> </>}
	</div>
